// extracted by mini-css-extract-plugin
export default {"list":"IllustrationList_list__VPaWN","item":"IllustrationList_item__cb5dh","text":"IllustrationList_text__VrfO1"};